<div class="w-full" style="min-width: 480px">
    <h2 mat-dialog-title class="text-xl">Record New Quote</h2>
    <p class="text-secondary text-sm mb-2">
        {{ data.partNumber }} (current cost:
        {{ (data.currentCost ?? 0) | currency: "GBP" }})
    </p>

    @if (form) {
    <form
        [formGroup]="form"
        class="grid grid-cols-2 gap-x-6 gap-y-3 w-full mt-4"
    >
        <mat-form-field
            class="col-span-2 fuse-mat-dense w-full"
            [subscriptSizing]="'dynamic'"
        >
            <mat-label>Supplier</mat-label>
            <!-- Type-to-search dropdown, same idiom as the quote board's customer picker:
                 the control holds the supplier ID, the input shows its name. -->
            <input
                matInput
                formControlName="supplierId"
                [matAutocomplete]="supplierAuto"
                (input)="filterSuppliers($event)"
                (focus)="filterSuppliers(null)"
                (blur)="clearIfNotPicked()"
                placeholder="Type to search"
                autocomplete="one-time-code"
            />
            <mat-autocomplete #supplierAuto="matAutocomplete" [displayWith]="supplierName">
                @for (supplier of filteredSuppliers; track supplier.supplierId) {
                <mat-option [value]="supplier.supplierId">
                    {{ supplier.name }}
                </mat-option>
                } @empty {
                <mat-option [disabled]="true">No matches</mat-option>
                }
            </mat-autocomplete>
            <mat-icon matSuffix class="icon-size-5 text-secondary">expand_more</mat-icon>
        </mat-form-field>
        <mat-form-field
            class="fuse-mat-dense w-full"
            [subscriptSizing]="'dynamic'"
        >
            <mat-label>Quoted Cost (per unit)</mat-label>
            <!-- Entering a cost raises the pack question, which converts a pack price down
                 to the per-unit figure this field is labelled for. -->
            <input
                matInput
                type="number"
                step="0.0001"
                min="0.0001"
                formControlName="cost"
                (blur)="costBlurred()"
            />
            <span matPrefix>£</span>
        </mat-form-field>
        <mat-form-field
            class="fuse-mat-dense w-full"
            [subscriptSizing]="'dynamic'"
        >
            <mat-label>Quote Date</mat-label>
            <input
                matInput
                formControlName="quoteDate"
                [matDatepicker]="quoteDatePicker"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="quoteDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #quoteDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="col-span-2 flex items-center gap-2 mt-2">
            <mat-checkbox
                formControlName="setAsPrimarySupplier"
                color="primary"
            ></mat-checkbox>
            <mat-label>Set as primary supplier for this part</mat-label>
        </div>
        <p class="col-span-2 text-secondary text-xs mt-2">
            Note: Part cost is updated only when the quote is higher than the
            current cost. Lower quotes are still recorded for history.
        </p>
    </form>
    }

    <div mat-dialog-actions class="flex justify-end gap-3 mt-6">
        <button mat-stroked-button (click)="cancel()" [disabled]="saving">
            Cancel
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="save()"
            [disabled]="!form?.valid || saving"
        >
            @if (!saving) {
            <span>Save Quote</span>
            } @if (saving) {
            <span>Saving...</span>
            }
        </button>
    </div>
</div>
